import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { keyGenClient } from '@/api/clients/keyGenClient';
import { NetworkError, ServerError } from '@/api/errors';
import type { KeyGenHeader, KeyGenRequest } from '@/api/types/keyGenTypes';

export function useKeyGenQuery(keyGenRequest: KeyGenRequest): UseQueryResult<KeyGenHeader[]> {
  return useQuery({
    retry: (failureCount, error) => {
      switch (error.constructor) {
        case NetworkError:
        case ServerError:
          return failureCount < 3;
      }

      return false;
    },
    throwOnError: false,
    queryKey: ['useKeyGenQuery', keyGenRequest],
    queryFn: async () => {
      const headers = await keyGenClient.getHeaders(keyGenRequest);

      return headers;
    },
    enabled: Boolean(keyGenRequest.user_entitlement && keyGenRequest.user_onboarding_preferences),
  });
}
